import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import Landing from "@/pages/Landing";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Dashboard from "@/pages/Dashboard";
import KebijakanPrivasi from "@/pages/KebijakanPrivasi";
import SyaratLayanan from "@/pages/SyaratLayanan";

const Spinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-sk-bg">
    <div className="h-10 w-10 rounded-full border-2 border-sk-line border-t-sk-brand animate-spin" />
  </div>
);

export const isActive = (user) =>
  user?.subscription_status === "active" &&
  user?.subscription_expires_at &&
  new Date(user.subscription_expires_at) > new Date();

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Spinner />;
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function RequireActive({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Spinner />;
  if (!user) return <Navigate to="/" replace />;
  if (!isActive(user)) return <Navigate to="/checkout" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/kebijakan-privasi" element={<KebijakanPrivasi />} />
      <Route path="/syarat-layanan" element={<SyaratLayanan />} />
      <Route path="/checkout" element={<RequireAuth><Checkout /></RequireAuth>} />
      <Route path="/checkout/success" element={<RequireAuth><PaymentSuccess /></RequireAuth>} />
      <Route path="/payment/success" element={<RequireAuth><PaymentSuccess /></RequireAuth>} />
      <Route path="/dashboard" element={<RequireActive><Dashboard /></RequireActive>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
